import equal from 'fast-deep-equal';
import { AiToolsChoices } from '@/services/settingsService/aiTypes';

/**
 * A tool requested from another surface (e.g. the Auto Color discovery modal)
 * should trigger a reprocess only when it actually changes the applied pipeline.
 * Otherwise a stale armed `shouldApplyPipelineChanges` could auto-submit a later
 * manual edit.
 */
export const shouldApplyRequestedTool = (
  nextChoices: AiToolsChoices,
  appliedChoices: AiToolsChoices
): boolean => !equal(appliedChoices, nextChoices);
